module.exports = {
  build: (current_month) ->
    weekStartsOn = HM.store.state.user.userdata.first_day
    from  = hm_date.startOfWeek(hm_date.startOfMonth(current_month), { weekStartsOn: weekStartsOn })
    to    = hm_date.endOfWeek(hm_date.endOfMonth(current_month), { weekStartsOn: weekStartsOn })
    days = {}

    newDate = from
    dateMonth = hm_date.format(current_month, 'M')
    weeks = []

    day_index = 0
    while newDate <= to
      otherMonth = hm_date.format(newDate, 'M') != dateMonth
      day =
        date         : hm_date.parse(newDate)
        dateIso      : hm_date.format(newDate)
        day          : hm_date.format(newDate, 'D')
        day_index    : (day_index += 1)
        transactions : []
      day.classes = ''
      day.classes += ' day--yesterday'   if day.dateIso == hm_date.constants.yesterday
      day.classes += ' day--today'       if day.dateIso == hm_date.constants.today
      day.classes += ' day--tomorrow'    if day.dateIso == hm_date.constants.tomorrow
      day.classes += ' day--other-month' if otherMonth == true

      firstDay = day if _.isEmpty(days)
      lastDay = day
      days[day.dateIso] = day
      newDate = hm_date.addDays(newDate, 1)

      lastWeek = _.last(weeks)
      if lastWeek and lastWeek.length < 7
        day.weekday = lastWeek.length + 1
        lastWeek.push day
      else
        weeks.push []
        day.weekday = 1
        _.last(weeks).push day
    return weeks
}
